const tokenize = (raw: unknown): string[] =>
  typeof raw === 'string'
    ? raw
        .split(';')
        .map(word => word.trim())
        .filter(Boolean)
    : []

export const tokenizeSortedWordsPool = (meta: Record<string, unknown>): string[] => [
  ...tokenize(meta.correct_words),
  ...tokenize(meta.wrong_words)
]
